import { api } from "@/lib/api";

let _cache = null;
let _promise = null;

/** Cached premium status for the current visitor (single fetch per page load). */
export function getPremiumStatus() {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;
  _promise = api
    .get("/premium/me")
    .then((r) => {
      _cache = r.data;
      return _cache;
    })
    .catch(() => {
      _cache = { premium: false, signed_in: false };
      return _cache;
    });
  return _promise;
}

export function clearPremiumCache() {
  _cache = null;
  _promise = null;
}

export async function startPremiumCheckout() {
  const { data } = await api.post("/premium/checkout", {
    origin_url: window.location.origin,
  });
  return data; // {url, session_id}
}

export async function cancelPremium() {
  const { data } = await api.post("/premium/cancel");
  return data;
}
